import {
  DestroyRef,
  Injectable,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { faro } from '@grafana/faro-web-sdk';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class FaroRouterTrackingService {
  private readonly destroyRef = inject(DestroyRef);
  private readonly router = inject(Router);

  private previousPath = this.router.url;

  start(): void {
    this.trackView(this.previousPath);

    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        ),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((event) => {
        const to = (event as NavigationEnd).urlAfterRedirects;

        this.trackView(to);
        this.previousPath = to;
      });
  }

  private trackView(path: string): void {
    faro?.api?.setView({ name: path });
    faro?.api?.setPage(path);
  }
}

export function provideFaroRouterTracking() {
  return provideAppInitializer(() => {
    inject(FaroRouterTrackingService).start();
  });
}
